import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

interface UseIsScrollTopParams {
  offset?: number;
  defaultValue?: boolean;
}

interface UseIsScrollTopResult {
  isScrollTop: boolean;
}

export const useIsScrollTop = (
  { offset = 0, defaultValue = false }: UseIsScrollTopParams = {
    offset: 0,
    defaultValue: false,
  },
): UseIsScrollTopResult => {
  const [isScrollTop, setIsScrollTop] = useState(defaultValue);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = throttle(() => {
      setIsScrollTop(window.scrollY <= offset);
    }, 100);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offset]);

  return {
    isScrollTop,
  };
};
